export default __webpack_public_path__ + "static/media/chevrons-up-down-24.a7d3ffef.svg";